import { bootstrapApplication } from '@angular/platform-browser';
import { appGuestConfig } from './app/app-guest.config';
import { AppGuest } from './app/app-guest';

// GUEST-ONLY entry point. Builds the public "view shared draft" experience as
// a standalone artifact (see the `express_guest` project in angular.json).
//
// Mirror of main.ts: silence noisy console output once deployed off-localhost,
// keep warn/error for production diagnostics.
const isLocalhost = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
if (!isLocalhost) {
  const noop = (): void => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}

bootstrapApplication(AppGuest, appGuestConfig)
  .catch((err) => console.error(err));
